export type Environment = {
  apiUrl: string;
  wssUrl: string;
};

export const getEnvironment = (): Environment => {
  if (typeof import.meta.env.REACT_APP_API_URL === 'string') {
    return {
      apiUrl: import.meta.env.REACT_APP_API_URL,
      wssUrl: import.meta.env.REACT_APP_API_URL.replace('http', 'ws'),
    };
  }

  return {
    apiUrl: '',
    wssUrl: '',
  };
};
